<template>
    <div
        :data-variant_id="variant.id"
        :data-product_id="variant.product_id"
        :class="productCardClass()"
        class="intro-product-card"
        :id="`gtm-product-card-${variant.title}`"
    >
        <!-- Product Card Favourite Area-->
        <!-- Product add to favourites button -->
        <span v-if="productVariant.is_customer_favourite === true"
              title="Remove from your Favourites"
              @click="removeFromFavourites"
              class="product-card-is-favourite flex-shrink-0 sm:ml-6 rounded-full p-[6px] focus:outline-none focus:ring-none focus:ring-brand-600 focus:ring-offset-2 intro-js-favorites-remove"
              :id="`gtm-favourites-heart-${variant.id}`"
        >
              <svg class="h-[22px] w-[22px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.273 23.323" aria-hidden="true">
                  <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M13.589,45.021l.639-.638a7.749,7.749,0,0,1,6.685-2.126,7.612,7.612,0,0,1,6.36,7.511v.309a7.969,7.969,0,0,1-2.536,5.833L15.112,64.9a2.165,2.165,0,0,1-2.951,0L2.535,55.909A7.976,7.976,0,0,1,0,50.076v-.309a7.614,7.614,0,0,1,13-5.384Zm0,2.413-1.8-1.848A5.947,5.947,0,0,0,1.657,49.767v.309A6.317,6.317,0,0,0,3.7,54.662l9.625,8.986a.441.441,0,0,0,.266.123.5.5,0,0,0,.362-.123l9.626-8.986a6.284,6.284,0,0,0,1.992-4.586v-.309A5.912,5.912,0,0,0,15.48,45.585Z"
                      transform="translate(0 -42.152)"
                      fill="currentColor"
                  />
              </svg>
        </span>

        <span v-else
              title="Add to your Favourites"
              @click="addToFavourites"
              class="product-card-not-favourite flex-shrink-0 sm:ml-6 rounded-full p-[6px] focus:outline-none focus:ring-none focus:ring-brand-600 focus:ring-offset-2 intro-js-favorites-remove"
              :id="`gtm-favourites-heart-${variant.id}`"
        >
              <svg class="h-[22px] w-[22px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.273 23.323" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.589,45.021l.639-.638a7.749,7.749,0,0,1,6.685-2.126,7.612,7.612,0,0,1,6.36,7.511v.309a7.969,7.969,0,0,1-2.536,5.833L15.112,64.9a2.165,2.165,0,0,1-2.951,0L2.535,55.909A7.976,7.976,0,0,1,0,50.076v-.309a7.614,7.614,0,0,1,13-5.384Zm0,2.413-1.8-1.848A5.947,5.947,0,0,0,1.657,49.767v.309A6.317,6.317,0,0,0,3.7,54.662l9.625,8.986a.441.441,0,0,0,.266.123.5.5,0,0,0,.362-.123l9.626-8.986a6.284,6.284,0,0,0,1.992-4.586v-.309A5.912,5.912,0,0,0,15.48,45.585Z" transform="translate(0 -42.152)" fill="currentColor"/>
              </svg>
        </span>

        <!--
            Layout classes: by default we keep the responsive grid (mobile/tablet)
            that switches to a vertical flex column at lg. When `vertical` is true
            (e.g. banner product modal carousel), always use the lg column layout so
            cards stay portrait on smaller screens too.
        -->
        <div
            class="w-full h-full"
            :class="verticalLayoutClass"
        >
            <!-- Product Name -->
            <a
                :href="variant.link"
                class="z-50"
                :class="vertical
                    ? 'order-2 shrink-0'
                    : 'col-span-12 col-start-2 col-end-12 lg:col-auto lg:order-2 lg:shrink-0'"
            >
                <h3 class="card-title h-auto text-base text-ellipsis"
                    style="-webkit-line-clamp: 2; height: 2rem"
                >
                    {{ variant.title }}
                </h3>
            </a>

                <div
                    class="justify-center"
                    :class="vertical
                        ? 'flex flex-col w-full order-1 shrink-0'
                        : 'flex flex-col-reverse col-span-5 min-w-[100px] lg:w-full lg:col-auto lg:flex lg:flex-col lg:order-1 lg:shrink-0'"
                >
                    <div :class="vertical ? 'relative' : 'lg:relative'">
                        <!-- Product Card Image -->
                        <div class="product-card-img-container">
                            <a :href="variant.link">
                                <img :src="variant.imageUrl" :alt="variant.title">
                            </a>
                        </div>

                        <!-- On Sale/Discounted/Recondition Badge  -->
                        <div class="listing-badge">

                            <!-- Clearance-->
                            <p>
                                <span class="bg-blue-400" v-if="variant.is_clearance && !this.associatedPart"><i class="fa fa-percent"></i>Clearance</span>
                            </p>

                            <!-- New -->
                            <p>
                                <span class="bg-orange-400" v-if="variant.is_new && !this.associatedPart"><i class="fa fa-star rotate-45"></i>New</span>
                            </p>

                            <!-- Best Seller -->
                            <p>
                            <span class="bg-purple-600" v-if="variant.is_best_seller && !this.associatedPart">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14.99" height="14.99" viewBox="0 0 14.99 14.99">
                                    <path id="medal" d="M8.795,8.063,8.217,6.892a.833.833,0,0,0-1.442,0L6.2,8.063,4.9,8.253a.792.792,0,0,0-.646.545.8.8,0,0,0,.2.827l.937.908-.223,1.288a.809.809,0,0,0,.8.943.781.781,0,0,0,.37-.094l1.156-.608,1.156.607a.779.779,0,0,0,.364.09.808.808,0,0,0,.8-.939L9.6,10.536l.937-.911a.806.806,0,0,0-.447-1.372Zm-.2,2.143.258,1.506L7.494,11l-1.357.731L6.4,10.206,5.3,9.138l1.512-.222.677-1.371.677,1.371,1.512.222ZM7.495,4.684a5.153,5.153,0,1,0,5.153,5.153A5.153,5.153,0,0,0,7.495,4.684Zm0,9.369a4.216,4.216,0,1,1,4.216-4.216A4.221,4.221,0,0,1,7.495,14.053ZM3.279,5.621a.468.468,0,0,0,.388-.731L.991.936,3.883.907,5.759,4.034a.468.468,0,0,0,.8-.481L4.687.426A.88.88,0,0,0,3.935,0H.877A.876.876,0,0,0,.155,1.371L2.891,5.414A.468.468,0,0,0,3.279,5.621ZM14.89.471A.872.872,0,0,0,14.114,0H11.055A.878.878,0,0,0,10.3.425L8.427,3.555a.468.468,0,0,0,.8.481l1.824-3.1H14L11.322,4.889a.469.469,0,0,0,.777.526l2.733-4.037A.873.873,0,0,0,14.89.471Z" transform="translate(0)" fill="#fff"/>
                                </svg>
                                Bestseller
                            </span>
                            </p>

                            <!-- Sustainable -->
                            <p>
                            <span class="bg-green-600" v-if="variant.is_sustainable && !this.associatedPart">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15.322" height="13.407" viewBox="0 0 15.322 13.407">
                                    <path id="leaf" d="M14.549,32.279a.584.584,0,0,0-.12-.159.479.479,0,0,0-.736.124,4.2,4.2,0,0,1-3.771,2.15H7.871a5.035,5.035,0,0,0-5,5.063,4.949,4.949,0,0,0,.031.5A8.928,8.928,0,0,0,.013,44.825a.44.44,0,0,0,.367.542.124.124,0,0,0,.1.039.478.478,0,0,0,.467-.379,7.962,7.962,0,0,1,2.194-3.986,4.933,4.933,0,0,0,.324.772h0a5,5,0,0,0,4.4,2.635,4.564,4.564,0,0,0,.511-.027c4.024-.293,6.944-3.821,6.944-8.394A9.46,9.46,0,0,0,14.549,32.279ZM8.264,43.466a3.7,3.7,0,0,1-.422.023,4.037,4.037,0,0,1-3.558-2.131,3.971,3.971,0,0,1-.373-1.007A7.977,7.977,0,0,1,8.747,38.7h1.284a.474.474,0,0,0,.479-.452.5.5,0,0,0-.479-.479H8.747a8.915,8.915,0,0,0-4.917,1.49,4.115,4.115,0,0,1,4.013-3.884H9.895a5.236,5.236,0,0,0,4.064-1.852,7.65,7.65,0,0,1,.408,2.5C14.366,40.085,11.82,43.212,8.264,43.466Z" transform="translate(-0.002 -31.999)" fill="#fff"/>
                                </svg>
                                Sustainable
                            </span>
                            </p>

                            <!-- Associated Part -->
                            <p>
                            <span class="bg-red-600 text-xs" v-if="this.associatedPart">
                                <svg xmlns="http://www.w3.org/2000/svg" class="fill-white" width="15.322" height="13.407" viewBox="0 0 512 512">
                                    <path d="M301.148 394.702l-79.2 79.19c-50.778 50.799-133.037 50.824-183.84 0-50.799-50.778-50.824-133.037 0-183.84l79.19-79.2a132.833 132.833 0 0 1 3.532-3.403c7.55-7.005 19.795-2.004 20.208 8.286.193 4.807.598 9.607 1.216 14.384.481 3.717-.746 7.447-3.397 10.096-16.48 16.469-75.142 75.128-75.3 75.286-36.738 36.759-36.731 96.188 0 132.94 36.759 36.738 96.188 36.731 132.94 0l79.2-79.2.36-.36c36.301-36.672 36.14-96.07-.37-132.58-8.214-8.214-17.577-14.58-27.585-19.109-4.566-2.066-7.426-6.667-7.134-11.67a62.197 62.197 0 0 1 2.826-15.259c2.103-6.601 9.531-9.961 15.919-7.28 15.073 6.324 29.187 15.62 41.435 27.868 50.688 50.689 50.679 133.17 0 183.851zm-90.296-93.554c12.248 12.248 26.362 21.544 41.435 27.868 6.388 2.68 13.816-.68 15.919-7.28a62.197 62.197 0 0 0 2.826-15.259c.292-5.003-2.569-9.604-7.134-11.67-10.008-4.528-19.371-10.894-27.585-19.109-36.51-36.51-36.671-95.908-.37-132.58l.36-.36 79.2-79.2c36.752-36.731 96.181-36.738 132.94 0 36.731 36.752 36.738 96.181 0 132.94-.157.157-58.819 58.817-75.3 75.286-2.651 2.65-3.878 6.379-3.397 10.096a163.156 163.156 0 0 1 1.216 14.384c.413 10.291 12.659 15.291 20.208 8.286a131.324 131.324 0 0 0 3.532-3.403l79.19-79.2c50.824-50.803 50.799-133.062 0-183.84-50.802-50.824-133.062-50.799-183.84 0l-79.2 79.19c-50.679 50.682-50.688 133.163 0 183.851z"/>
                                </svg>
                                Perfectly Paired
                            </span>
                            </p>
                        </div>
                    </div>
                    <!-- Info -->
                </div>

                <!-- Info -->
                <div
                    class="flex flex-col text-center w-full"
                    :class="vertical
                        ? 'order-3 flex-1'
                        : 'col-span-6 col-start-7 col-end-12 lg:col-auto lg:order-3 lg:flex-1'"
                >
                    <!-- Size Attribute -->
                    <div v-if="variant.size_attribute" class="product-card-attributes">
                        <p class="item">{{ variant.size_attribute }}</p>
                    </div>

                    <!-- SKU-->
                    <div class="item">
                        <fa-icon
                            icon="fa fa-barcode"
                        /> <span>{{ variant.sku }}</span>
                    </div>

                    <!-- Price-->
                    <div class="price">
                        <div v-if="variant.price !== '0.00'">
                            {{ currency(variant.price) }}
                        </div>
                        <div v-else>
                            Call us for pricing
                        </div>

                        <ProductSaving
                            :item="variant"
                        />

                        <div class="product-sold-by text-xs font-base text-gray-600 intro-shop-sold-by">
                            {{ variant.sold_by }}
                        </div>
                    </div>

                    <!-- Product Card Stars / Rating (hidden until we are ready to use it) -->
                    <!-- <div class="text-center">
                        <product-rating></product-rating>
                    </div> -->

                    <!-- Qty Input & Add, Remove CTA's -->
                    <div
                        class="w-full mt-4 lg:mt-auto lg:pt-4"
                    >
                        <ProductQuantity
                            :wrapper="wrapper"
                            :productVariant="variant"
                            displayType="output"
                        />
                    </div>
                </div>
        </div>
    </div>
</template>

<script>

//import ProductRating from "./ProductRating";
import currencyMixin from '@mixins/currency.js'
import ProductQuantity from './ProductQuantity.vue'
import { mapState } from 'pinia'
import { useBasketStore } from '@stores/Portal/basket/index.js'
import { useProductStore } from '@stores/Portal/product/index.js'
import GtmEvent from "@modules/GtmEvent.js";
import ProductSaving from "./ProductSaving.vue";

export default {
    name: "ProductVariant",
    mixins: [ currencyMixin ],
    components: {
        ProductQuantity,
        ProductSaving
    },
    props: {
        wrapper: {
            default: undefined,
        },
        variant: {
            required: true,
        },
        associatedPart: {
            default: undefined,
        },
        // When true, always use the desktop (lg) vertical card layout instead of
        // the mobile/tablet horizontal grid. Used by the banner products modal
        // carousel so cards stay portrait on all breakpoints. Default false so
        // product listings keep their existing responsive layout.
        vertical: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState(useBasketStore, [ 'basket' ]),
        verticalLayoutClass() {
            if (! this.vertical) {
                return 'grid items-center grid-cols-12 lg:flex lg:flex-col lg:items-stretch min-h-[225px] lg:min-h-[460px]'
            }

            return 'flex flex-col items-stretch min-h-[360px]'
        },
    },
    methods: {
        // Favourites
        async addToFavourites() {
            const res = await fetch(`/api/favourites/${this.productVariant.id}/add`, this.apiConfig);
            if (res.ok) {
                const data = await res.json();

                Object.assign(this.variant, data.item)
                this.productVariant = this.variant

                this.$root.$emit('updateProductVariant', this.productVariant)
                void useProductStore().refreshProductListMeta()
            }

            new GtmEvent({
                eventName: "add_to_wishlist",
                items: this.productVariant
            }).trackGtmEvent()

        },
        async removeFromFavourites() {
            const res = await fetch(`/api/favourites/${this.productVariant.id}/remove`, this.apiConfig);
            if (res.ok) {
                const data = await res.json();

                Object.assign(this.variant, data.item)
                this.productVariant = this.variant

                this.$root.$emit('updateProductVariant', this.productVariant)
                void useProductStore().refreshProductListMeta()
            }
        },
        productCardClass() {
            // There are easier ways to do this but this enables more complex logic to be applied in the future

            let classString = "";

            // Check if exists in basket.
            if (
                this.basket.basket_items.some(basketItem => (
                    basketItem.hasOwnProperty('product_variant_id')
                    && basketItem.product_variant_id == this.variant.id
                ))
            ) {
                classString = "product-in-basket";
            }

            // Not in basket and not favourite
            if (classString === "") {
                classString = "ProductCard";
            }


            // All other class items
            classString = classString + " group product-card h-full";

            return classString;
        }
    },
    data() {
        return {
            productVariant: this.variant,
            apiConfig: {
                headers: {
                    Authorization: 'Bearer ' + window.Laravel.api_token,
                    Accept: 'application/json'
                }
            },
            productVariantBasketQuantity: 0
        }
    }
}
</script>

